import React, { Component, Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Spinner from "../app/shared/Spinner";
import AddCustomerUser from "./Screens/AddCustomerUser";
import AddDevice from "./Screens/AddDevice";
import AddUser from "./Screens/AddUser";
import ChangePassword from "./Screens/ChangePassword";
import CreateCustomer from "./Screens/CreateCustomer";
import CustomerEditScreen from "./Screens/CustomerEditScreen";
import Customers from "./Screens/Customers";
import CustomerUsers from "./Screens/CustomerUsers";
import Device from "./Screens/Device";
import EditUserProfile from "./Screens/EditUserProfile";
import ForgotPassword from "./Screens/ForgotPassword";
import TenantDashboard from "./Screens/TenantDashboard";
import UserProfile from "./Screens/UserProfile";
import Users from "./Screens/Users";
import TenantSingleDevice from "./Screens/TenantSingleDevice";
import Alerts from "./Screens/Alerts";
import Messages from "./Screens/Messages";
import ListPurifier from "./Screens/ListPurifier";
import AddPurifier from "./Screens/AddPurifier";
import ListShipments from "./Screens/ListShipment";
import AddShipment from "./Screens/AddShipment";
import BoxCategory from "./Screens/BoxCategories";
import ViewCustomers from "./Screens/ViewCustomers";
// const Dashboard = lazy(() => import("./Screens/Dashboard"));
// const Login = lazy(() => import("./Screens/Login"));
import Dashboard from "./Screens/Dashboard";
import Login from "./Screens/Login";
import Login2 from "./Screens/Login_new";
import QuestionIndex from "./Screens/QuestionIndex";
import QuestionsAll from "./Screens/QuestionsAll";
import DeviceHistoricalData from "./Components/DeviceHistoricalData";
import MasterDashboard from "./Screens/MasterDashboard";
import SysAdminDashboard from "./Screens/SysAdminDashboard";
import HistoricalData from "./Screens/HistoricalData";
import Tenants from "./Screens/Tenants";
import PageNotFound from "./Screens/PageNotFound";
import AddTenant from "./Screens/AddTenant";
import DeviceForAdmin from "./Screens/DeviceForAdmin";
import CustomersForAdmin from "./Screens/CustomersForAdmin";
import DeviceHealthStatus from "./Screens/DeviceHealthStatus";
import AddDeviceSysAdmin from "./Screens/AddDeviceSysAdmin";
import AddDevicePartner from "./Screens/PartnerScreens/AddDevicePartner";
import ListTenantDevices from "./Screens/ListTenantDevices";
import CreatePassword from "./Screens/CreatePassword";
import ResetPassword from "./Screens/ResetPassword";
import ConnectDevice from "./Screens/ConnectDevice";
import CreateQuestions from "./Screens/CreateQuestions";
import ViewUserResponse from "./Screens/ViewUserResponse";
import FillUserResponse from "./Screens/FillUserResponse";
import UserFeedback from "./Screens/UserFeedback";
import UpdateDeviceSysAdmin from "./Screens/UpdateDeviceSysAdmin";
import UserQuestionnaire from "./Screens/UserQuestionnaire";
import HistoricalDataJapan from "./Screens/HistoricalDataJapan";
import Partners from "./Screens/Partners";
import AddPartners from "./Screens/AddPartners";
import PartnerDashboard from "./Screens/PartnerScreens/PartnerDashboard";
import ShipmentDashboard from "./Screens/PartnerScreens/ShipmentDetailsPage";
import ManageCustomers from "./Screens/PartnerScreens/manageCustomer";
import ManageCustomerUsers from "./Screens/PartnerScreens/customUsers";
import PartnerCreateCustomer from "./Screens/PartnerScreens/addCustomerUser";
import AgentDashboard from "./Screens/PartnerScreens/AgentDashboard";
import ListPartnerDevices from "./Screens/PartnerScreens/PartnerListDevices";
import PartnerShipments from "./Screens/PartnerScreens/parnterShipments";
import ShipmentDetailsPage from "./Screens/ShipmentDetailView";
import Category from "./Screens/categories";
import LogisticManager from "./Screens/LogisticManager";
import UserRolesIndexPage from "./Screens/UserRolesIndexPage";
import AddUserRoles from "./Screens/AddUserRoles";
import QuestionSupportIndex from "./Screens/QuestionSupportindex";
import Lead from "./Screens/Lead";
import AddLeads from "./Screens/AddLeads";
import EditLeads from "./Screens/EditLeads";
import ViewLeads from "./Screens/ViewLeads";
import AddSubscriptions from "./Screens/AddSubscriptions";
import SubscriptionIndex from "./Screens/SubscriptionIndex";
import AddSubscribers from "./Screens/AddSubscribers";
import ViewSubscriptions from "./Screens/ViewSubscriptions";
import EditSubscriptions from "./Screens/EditSubscriptions";
import AddLogisticManager from "./Screens/AddLogisticManager";
import EditLogisticManager from "./Screens/EditLogisticManager";
import LogisticManagerDashboard from "./Screens/logisticManagerDashboard";
import EditShipment from "./Screens/EditShipment";
import AssignDeviceToCustomer from "./Screens/PartnerScreens/assignedCustomer";
import PartnerCreateShipment from "./Screens/PartnerScreens/CreateShipment";
import ManagerShipment from "./Screens/ManagerCraeteShipment";
import ManagerShipmentDetailsPage from "./Screens/mangaershipmentdetailsview";
import ManagerEditShipment from "./Screens/managereditshipment";
import LeadExecutiveIndex from "./Screens/LeadExecutive/LeadExecutiveIndex";
import LeadExecutiveAdd from "./Screens/LeadExecutive/LeadExecutiveAdd";
import LeadExecutiveEdit from "./Screens/LeadExecutive/LeadExecutiveEdit";
import LeadExecutiveDashboard from "./Screens/LeadExecutive/LeadExecutiveDashboard";
import FollowUp from "./Screens/FollowUp";
import FollowupHistory from "./Screens/FollowupHistory";
import LeadExe from "./Screens/LeadExe";
import Sysadmin_subscriber from "./Screens/Sysadmin_subscriber";
import CreateTicket from "./Screens/CreateTicket";
import Tickets from "./Screens/Tickets";
import Support from "./Screens/SupportForUser";
import EditTicket from "./Screens/EditTicket";
import MyTickets from "./Screens/MyTickets";
import SupportAdminDashboard from "./Screens/SupportAdmin/SupportAdminDashboard";
import ViewDevice from "./Screens/ViewDevice";
import ReturnShipmentDetails from "./Screens/PartnerScreens/returnShipmentDetails";
import ViewDeviceDetails from "./Screens/PartnerScreens/ViewDeviceDetails";
import ListPartnerDamagedDevices from "./Screens/PartnerScreens/PartnerListDamagedDevices";
import ViewDamageDeviceDetails from "./Screens/PartnerScreens/ViewDamageDeviceDetails";
import ManageUsers from "./Screens/manageUsers";
import AddUserSysAdmin from "./Screens/AddUserSysAdmin";
import EditUserSysAdmin from "./Screens/EditUserSysAdmin";
import ViewTicket from "./Screens/ViewTicket";
import CustomerDashboard from "./Screens/CutomerDashboard";
import ReturnShipment from "./Screens/PartnerScreens/returnShipment";
import SysadminEditProfile from "./Screens/SysAdminEditProfile";
import LeadUserFeedback from "./Screens/LeadExecutive/LeadUserFeedack";
import SysAdminDamagedDevice from "./Screens/SysAdminDamagedDevice";
import SysAdminViewDamageDeviceDetails from "./Screens/SysAdminViewDamageDeviceDetails";
import PartnerList from "./Screens/PartnerScreens/PartnerList";
import PartnerEditShipment from "./Screens/PartnerScreens/partnerEditShipment";
import partnerEditReturnShipment from "./Screens/PartnerScreens/partnerEditReturnShipment";
import ManagerShipmets from "./Screens/LogisticManager/ManagerShipments";
import ITExecutiveDashboard from "./Screens/ITExecutive/ITExecutiveDashboard";
import CreatePasswordWithId from "./Screens/PasswordWithId";
import AdminLeadView from "./Screens/AdminLeadView";
import PartnerLead from "./Screens/PartnerScreens/PartnerLead";
import PartnerLeadView from "./Screens/PartnerScreens/PartnerLeadView";
import ViewSupportUsers from "./Screens/ViewSupportUsers";
import ViewITExecutives from "./Screens/ViewITExecutives";
import SupportUserEdit from "./Screens/SupportUserEdit";
import PartnerEditProfile from "./Screens/PartnerEditProfile";
import ViewSupportAdminByPartners from "./Screens/ViewSupportAdminByPartners";
import ViewITExecutivesByPartner from "./Screens/ViewITExecutivesByPartner";
import leadExeCustomer from "./Screens/LeadExecutive/leadExeCustomer";
import LeadExeCustomer from "./Screens/LeadExecutive/leadExeCustomer";
import UsersforLeadExe from "./Screens/UsersforLeadExe";
import ManagerReturnShipments from "./Screens/LogisticManager/ManagerReturnShipments";
import ManagerCreateRShipment from "./Screens/ManagerCreateRShipment";
import PartnerLogistic from "./Screens/PartnerScreens/PartnerLogistic";
import ListReturnShipments from "./Screens/ListReturnShipments";
import Mngreditreturnshipment from "./Screens/mngreditreturnshipment";
import SupportAdminTickets from "./Screens/SupportAdmin/SupportAdminTickets";
import ITExecutiveTickets from "./Screens/ITExecutive/ITExecutiveTickets";
import ManageProfileInternal from "./Screens/ManageProfileInternal";
import EditQuestions from "./Screens/EditQuestions";
import PartnerAddUser from "./Screens/PartnerScreens/PartnerAddUser";
import PartnerEditUser from "./Screens/PartnerScreens/PartnerEditUser";
import PartnerUserFeedback from "./Screens/PartnerScreens/PartnerUserFeedback";
// import CustomerAssign from "./Screens/PartnerScreens/CustomerAssign";
const AppRoutes = () => {
  let details = localStorage.getItem("userDetails");
  details = JSON.parse(details);
  let userPermission = localStorage.getItem("userPermission");
  let isPartnerLogin = localStorage.getItem("isPartnerLogin");
  //  userPermission = JSON.parse(userPermission);
  //  const n = userPermission.length;

  return (
    <Suspense fallback={<Spinner />}>
      {!localStorage.getItem("token") ? (
        <Switch>
          <Route path="/" component={Login2} exact />
          {/* <Route path="/" component={SysAdminDashboard} exact /> */}

          <Route path="/forgotPassword" component={ForgotPassword} exact />
          <Route
            path="/createPassword/:token"
            component={CreatePassword}
            exact
          />
          <Route
            path="/passwordCreate/:id"
            component={CreatePasswordWithId}
            exact
          />
          <Route path="/resetPassword" component={ResetPassword} exact />
          <Route component={PageNotFound} />
        </Switch>
      ) : (
        <>
          {localStorage.getItem("isLeadExecutive") ? (
            <>
              <Route
                path="/dashboard"
                component={LeadExecutiveDashboard}
                exact
              />
              <Route path="/get-leads" component={LeadExe} />
              <Route path="/leads/create" component={AddLeads} />
              <Route path="/leads/edit/:id" component={EditLeads} />
              <Route path="/leads/view/:id" component={ViewLeads} />
              <Route
                path="/subscription/create/:id"
                component={AddSubscriptions}
              />
              <Route path="/users/:id" component={Users} />
              <Route path="/subscriptions" component={SubscriptionIndex} />
              <Route path="/customer" component={LeadExeCustomer} />

              <Route
                path="/viewSubscriptionUser/:id"
                component={ViewSubscriptions}
              />
              <Route
                path="/editSubscriptionUser/:id"
                component={EditSubscriptions}
              />
              <Route path="/user-feedback" component={LeadUserFeedback} />
              <Route
                path="/viewResponse/:userId/:masterId"
                component={ViewUserResponse}
              />
              <Route
                path="/fill-user-response/:userId/:masterId"
                component={FillUserResponse}
              />
              <Route path="/subscribers/create" component={AddSubscribers} />
              <Route path="/follow-up" component={FollowUp} />
              <Route path="/followup-history/:id" component={FollowupHistory} />
              <Route path="/questions" component={QuestionsAll} />
              <Route path="/manage-profile" component={ManageProfileInternal} />
            </>
          ) : localStorage.getItem("isSupportAdmin") ? (
            <>
              <Switch>
                <Route path="/dashboard" component={SupportAdminDashboard} />
                <Route
                  path="/it-executives"
                  component={ViewITExecutivesByPartner}
                />
                <Route
                  path="/questionssupport"
                  component={QuestionSupportIndex}
                  exact
                />
                <Route path="/supports/createticket" component={CreateTicket} />
                <Route path="/supports/EditTicket/:id" component={EditTicket} />
                <Route path="/supports/ViewTicket/:id" component={ViewTicket} />
                <Route
                  path="/support-tickets"
                  component={SupportAdminTickets}
                />
                <Route path="/questions" component={QuestionsAll} />
                <Route
                  path="/manage-profile"
                  component={ManageProfileInternal}
                />
              </Switch>
            </>
          ) : localStorage.getItem("isLogisticManager") ? (
            <>
              <Route
                path="/dashboard"
                component={LogisticManagerDashboard}
                exact
              />
              <Route path="/myshipments" component={ManagerShipmets} exact />
              <Route
                path="/returnShipment"
                component={ManagerReturnShipments}
                exact
              />
              <Route path="/create/shipment" component={ManagerShipment} />
              <Route
                path="/create/returnshipment"
                component={ManagerCreateRShipment}
              />
              <Route
                path="/shipment/detail/:id"
                component={ManagerShipmentDetailsPage}
              />

              <Route
                path="/managershipment/edit/:id"
                component={ManagerEditShipment}
              />
              <Route
                path="/managerreturnshipment/edit/:id"
                component={Mngreditreturnshipment}
              />
              <Route path="/questions" component={QuestionsAll} />
              <Route path="/manage-profile" component={ManageProfileInternal} />
            </>
          ) : localStorage.getItem("isItExecutive") ? (
            <>
              <Switch>
                <Route path="/dashboard" component={ITExecutiveDashboard} />
                {/* <Route path="/questions" component={QuestionSupportIndex} /> */}
                <Route path="/supports" component={ITExecutiveTickets} exact />
                <Route path="/supports/ViewTicket/:id" component={ViewTicket} />
                <Route path="/questions" component={QuestionsAll} />
                <Route
                  path="/manage-profile"
                  component={ManageProfileInternal}
                />
              </Switch>
            </>
          ) : localStorage.getItem("isPartnerLogin") ? (
            <>
              <Route path="/dashboard" component={PartnerDashboard} exact />
              <Route path="/device/create" component={AddDevicePartner} />
              <Route path="/manageCustomer" component={ManageCustomers} exact />
              {/* <Route path="/users/:id" component={ManageCustomerUsers} /> */}
              <Route path="/user/create/:id" component={AddCustomerUser} />
              <Route path="/manageCustomer/users/:id" component={Users} />
              <Route
                path="/customer/create"
                component={PartnerCreateCustomer}
              />
              <Route
                exact
                path="/logisticmanagers/create"
                component={AddLogisticManager}
              />
              <Route
                exact
                path="/logisticmanagers/edit/:id"
                component={EditLogisticManager}
              />
              <Route path="/myshipments" component={PartnerShipments} exact />
              <Route
                path="/shipmentDetails/:id"
                component={ShipmentDashboard}
                exact
              />
              <Route
                path="/partnershipment/edit/:id"
                component={PartnerEditShipment}
              />
              <Route
                path="/partnerreturnshipment/edit/:id"
                PartnerEditReturnShipment
                component={partnerEditReturnShipment}
              />
              <Route path="/questions" component={QuestionsAll} />
              <Route
                path="/create-shipment"
                component={PartnerCreateShipment}
                exact
              />
              <Route path="/partner-list" component={PartnerList} exact />
              <Route
                path="/assigncustomer"
                component={AssignDeviceToCustomer}
                exact
              />
              <Route path="/returnShipment" component={ReturnShipment} exact />
              <Route
                path="/returnShipment/:id"
                component={ReturnShipmentDetails}
                exact
              />
              <Route
                exact
                path="/logisticmanagers"
                component={PartnerLogistic}
              />
              <Route
                path="/lead-executives"
                component={LeadExecutiveIndex}
                exact
              />
              <Route
                path="/lead-executives/edit/:id"
                component={LeadExecutiveEdit}
                exact
              />
              <Route path="/partner-devices" component={ListPartnerDevices} />
              <Route path="/partner-lead" component={PartnerLead} />
              <Route
                path="/partnerleads/view/:id"
                component={PartnerLeadView}
              />
              <Route
                path="/partner-damaged-devices"
                component={ListPartnerDamagedDevices}
              />
              <Route path="/device-details/:id" component={ViewDeviceDetails} />
              <Route
                path="/damage-device-details/:id"
                component={ViewDamageDeviceDetails}
              />
              <Route path="/user-feedback" component={PartnerUserFeedback} />
              <Route
                path="/viewResponse/:userId/:masterId"
                component={ViewUserResponse}
              />
              <Route
                path="/fill-user-response/:userId/:masterId"
                component={FillUserResponse}
              />
              <Route path="/profile" component={PartnerEditProfile} exact />
              <Route path="/manage-users" component={ManageUsers} exact />
              <Route
                path="/manage-users/add"
                component={PartnerAddUser}
                exact
              />
              <Route
                path="/manage-users/edit/:id"
                component={PartnerEditUser}
                exact
              />
              <Route path="/supports/createticket" component={CreateTicket} />
              <Route path="/supports/EditTicket/:id" component={EditTicket} />
              <Route path="/supports/ViewTicket/:id" component={ViewTicket} />
              <Route path="/supports" component={Tickets} exact />
              <Route
                path="/support-admin"
                component={ViewSupportAdminByPartners}
                exact
              />
              <Route
                path="/it-executives"
                component={ViewITExecutivesByPartner}
                exact
              />
              <Route
                path="/support-admin/edit/:id"
                component={SupportUserEdit}
              />
              <Route
                path="/it-executives/edit/:id"
                component={SupportUserEdit}
              />
              {/* <Route path="/assigncustomer/:id" component={CustomerAssign} /> */}
            </>
          ) : (
            <>
              <>
                {details.data.authority === "TENANT_ADMIN" ? (
                  <Switch>
                    <Route
                      exact
                      path="/dashboard"
                      component={TenantDashboard}
                    />
                    <Route
                      path="/customers"
                      component={Customers}
                      exact
                      protect
                    />
                    <Route
                      path="/customer/:id/edit"
                      component={CustomerEditScreen}
                    />
                    <Route path="/customer/create" component={CreateCustomer} />
                    <Route path="/users/:id" component={Users} />
                    <Route path="/user/create/:id" component={AddUser} />
                    <Route path="/devices" component={ListTenantDevices} />
                    <Route path="/device/create" component={AddDevice} />
                    {/* <Route path="/devices" component={Device} /> */}
                    {/* <Route path="/devices" component={ListTenantDevices} /> */}
                    <Route path="/profile" component={UserProfile} />
                    <Route path="/user/profile" component={EditUserProfile} />
                    <Route
                      path="/historicaldata"        // historicaldatajapan
                      component={HistoricalData}   // HistoricalDataJapan
                    />
                    <Route
                      path="/getSingleDeviceData/:id/:deviceName"
                      component={TenantSingleDevice}
                    />
                    <Route
                      path="/user/changePassword"
                      component={ChangePassword}
                    />
                    <Route path="/alerts" component={Alerts} />
                    <Route path="/messages" component={Messages} />
                    <Route
                      path="/deviceData"
                      component={DeviceHistoricalData}
                    />

                    <Route
                      path="/deviceData"
                      component={DeviceHistoricalData}
                    />
                    <Route path="/HistoricalData" component={HistoricalData} />
                    <Route
                      path="/DeviceHealthStatus"
                      component={DeviceHealthStatus}
                    />
                    <Route
                      path="/update-device-location/:deviceId"
                      component={UpdateDeviceSysAdmin}
                    />
                    <Route component={PageNotFound} />
                  </Switch>
                ) : (
                  <>
                    {details.data.authority === "SYS_ADMIN" ? (
                      <Switch>
                        {" "}
                        <Route
                          path="/dashboard"
                          // component={MasterDashboard}
                          component={SysAdminDashboard}
                          exact
                        />
                        <Route
                          path="/syssubscriber"
                          component={Sysadmin_subscriber}
                        />
                        <Route
                          path="/DamagedDevices"
                          component={SysAdminDamagedDevice}
                          exact
                        />
                        <Route
                          path="/DamagedDevices/SysAdminViewDamageDeviceDetails/:id"
                          component={SysAdminViewDamageDeviceDetails}
                          exact
                        />
                        <Route path="/devices" component={DeviceForAdmin} />
                        <Route
                          path="/device/create"
                          component={AddDeviceSysAdmin}
                        />
                        <Route path="/questions" component={QuestionsAll} />
                        <Route path="/viewDevices/:id" component={ViewDevice} />
                        <Route path="/tenants" component={Tenants} />
                        <Route path="/tenant/create" component={AddTenant} />
                        <Route
                          path="/customers"
                          component={CustomersForAdmin}
                          exact
                        />
                        <Route
                          path="/customers/view/:id"
                          component={ViewCustomers}
                        />
                        <Route path="/purifiers" component={ListPurifier} />
                        <Route
                          path="/myshipments"
                          component={ListShipments}
                          exact
                        />
                        <Route
                          path="/myreturnshipments"
                          component={ListReturnShipments}
                          exact
                        />
                        <Route
                          path="/shipment/create"
                          component={AddShipment}
                        />
                        <Route path="/partners" component={Partners} />
                        <Route path="/partner/create" component={AddPartners} />
                        <Route
                          path="/addusers"
                          component={UserRolesIndexPage}
                        />
                        <Route
                          path="/adduser/create"
                          component={AddUserRoles}
                        />
                        <Route path="/leads" component={Lead} exact />
                        {/* <Route path="/leads/create" component={AddLeads} /> */}
                        <Route path="/leads/edit/:id" component={EditLeads} />
                        <Route
                          path="/leads/view/:id"
                          component={AdminLeadView}
                        />
                        {/* <Route
                          path="/subscriptions/create/:id"
                          component={AddSubscriptions}
                        /> */}
                        <Route
                          path="/subscriptions"
                          component={SubscriptionIndex}
                        />
                        <Route
                          path="/viewSubscriptionUser/:id"
                          component={ViewSubscriptions}
                        />
                        <Route
                          path="/editSubscriptionUser/:id"
                          component={EditSubscriptions}
                        />
                        {/* <Route
                          path="/subscribers/create"
                          component={AddSubscribers}
                        /> */}
                        <Route
                          path="/supports/createticket"
                          component={CreateTicket}
                        />
                        <Route
                          path="/supports/EditTicket/:id"
                          component={EditTicket}
                        />
                        <Route path="/supports" component={Tickets} exact />
                        <Route
                          path="/supports/ViewTicket/:id"
                          component={ViewTicket}
                        />
                        <Route
                          path="/support-admin"
                          component={ViewSupportUsers}
                          exact
                        />
                        <Route
                          path="/it-executives"
                          component={ViewITExecutives}
                          exact
                        />
                        <Route
                          path="/support-admin/edit/:id"
                          component={SupportUserEdit}
                        />
                        <Route
                          path="/it-executives/edit/:id"
                          component={SupportUserEdit}
                        />
                        <Route
                          exact
                          path="/purifier/create"
                          component={AddPurifier}
                        />
                        <Route
                          exact
                          path="/boxcategories"
                          component={BoxCategory}
                        />
                        <Route
                          exact
                          path="/logisticmanagers"
                          component={LogisticManager}
                        />
                        <Route
                          exact
                          path="/logisticmanagers/create"
                          component={AddLogisticManager}
                        />
                        <Route
                          exact
                          path="/logisticmanagers/edit/:id"
                          component={EditLogisticManager}
                        />
                        <Route
                          path="/DeviceHealthStatus"
                          component={DeviceHealthStatus}
                        />
                        <Route
                          path="/myshipments/:id"
                          component={ShipmentDetailsPage}
                          exact
                        />
                        <Route
                          path="/myreturnshipments/:id"
                          component={ShipmentDetailsPage}
                          exact
                        />
                        <Route
                          path="/editShipment/:id"
                          component={EditShipment}
                        />
                        <Route path="/categories" component={Category} />
                        <Route
                          path="/createQuestion"
                          component={CreateQuestions}
                        />
                        <Route
                          path="/editQuestion/:id"
                          component={EditQuestions}
                        />
                        <Route
                          path="/getSingleDeviceData/:id/:deviceName"
                          component={TenantSingleDevice}
                        />
                        <Route
                          path="/viewResponse/:userId/:masterId"
                          component={ViewUserResponse}
                        />
                        <Route
                          path="/fill-user-response/:userId/:masterId"
                          component={FillUserResponse}
                        />
                        <Route path="/user-feedback" component={UserFeedback} />
                        <Route
                          path="/update-device-location/:deviceId"
                          component={UpdateDeviceSysAdmin}
                        />
                        <Route
                          path="/lead-executives"
                          component={LeadExecutiveIndex}
                          exact
                        />
                        <Route
                          path="/lead-executives/create"
                          component={LeadExecutiveAdd}
                          exact
                        />
                        <Route
                          path="/lead-executives/edit/:id"
                          component={LeadExecutiveEdit}
                          exact
                        />
                        <Route
                          path="/manage-users"
                          component={ManageUsers}
                          exact
                        />
                        <Route
                          path="/manage-users/add"
                          component={AddUserSysAdmin}
                          exact
                        />
                        <Route
                          path="/manage-users/edit/:id"
                          component={EditUserSysAdmin}
                          exact
                        />
                        <Route
                          path="/editProfile"
                          component={SysadminEditProfile}
                          exact
                        />
                        <Route
                          path="/change-password"
                          component={ChangePassword}
                          exact
                        />
                        <Route component={PageNotFound} />
                      </Switch>
                    ) : (
                      <Switch>
                        {/* <Route path="/dashboard" component={Dashboard} exact /> */}
                        <Route
                          path="/dashboard"
                          component={CustomerDashboard}
                          exact
                        />
                        <Route path="/profile" component={UserProfile} />
                        <Route
                          path="/user/profile"
                          component={EditUserProfile}
                        />
                        <Route
                          path="/customerUsers/:id"
                          component={CustomerUsers}
                        />
                        <Route path="/user/create" component={AddUser} />
                        <Route
                          path="/customerUser/create/:id"
                          component={AddCustomerUser}
                        />
                        <Route
                          path="/my-supports"
                          component={MyTickets}
                          exact
                        />
                        <Route
                          path="/my-supports/ViewTicket/:id"
                          component={ViewTicket}
                        />
                        <Route path="/createTickets" component={Support} />
                        <Route
                          path="/user/changePassword"
                          component={ChangePassword}
                        />
                        <Route path="/alerts" component={Alerts} />
                        <Route path="/messages" component={Messages} />
                        <Route
                          path="/connectDevice"
                          component={ConnectDevice}
                        />
                        <Route
                          path="/fill-response"
                          component={UserQuestionnaire}
                        />
                        <Route component={PageNotFound} />
                      </Switch>
                    )}
                  </>
                )}
              </>
            </>
          )}
        </>
      )}
    </Suspense>
  );
};

export default AppRoutes;
